import { createContext, useContext, useState, useEffect } from "react";

const CheckoutContext = createContext();

export const CheckoutProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [orderPlaced, setOrderPlaced] = useState(false);
  const [checkoutStarted, setCheckoutStarted] = useState(false);

  // ✅ persist (so refresh doesn't break flow)
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("checkoutState"));
    if (saved) {
      setCartItems(saved.cartItems || []);
      setSelectedPaymentMethod(saved.selectedPaymentMethod || null);
      setOrderPlaced(saved.orderPlaced || false);
      setCheckoutStarted(saved.checkoutStarted || false);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "checkoutState",
      JSON.stringify({
        cartItems,
        selectedPaymentMethod,
        orderPlaced,
        checkoutStarted,
      })
    );
  }, [cartItems, selectedPaymentMethod, orderPlaced, checkoutStarted]);

  return (
    <CheckoutContext.Provider
      value={{
        cartItems,
        setCartItems,
        selectedPaymentMethod,
        setSelectedPaymentMethod,
        orderPlaced,
        setOrderPlaced,
        checkoutStarted,
        setCheckoutStarted,
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckout = () => useContext(CheckoutContext);